import { useCallback } from "react";
import { useHospitalData } from "../contexts/HospitalDataProvider";
import { getJobDisplayName } from "../utils/roles";
import { useAllJobs } from "./useJobs";

/**
 * Returns a resolver that maps a `jobId` to its display name, falling back to the chosen department's
 * job list and then to the global `allJobs` list.
 */
export const useGetResolverJobDisplayName = (): ((jobId: string | undefined | null) => string) => {
	const { chosenDepartment } = useHospitalData();
	const { data: allJobs } = useAllJobs();

	return useCallback((jobId: string | undefined | null) => getJobDisplayName(jobId, chosenDepartment, allJobs), [chosenDepartment, allJobs]);
};
